// Word-level text reveal.
//
// Splits a string on whitespace and wraps each word in a span carrying its
// index as `--i`, so CSS can stagger a blur-in word by word once the nearest
// `[data-reveal]` ancestor turns `.is-visible`.
//
// WORDS, never letters: Arabic letters join, and splitting them into
// separate inline boxes breaks the joins and the shaping. The real spaces are
// kept as text nodes between the spans, so copy, search and screen readers
// read the sentence exactly as written.

import { Fragment } from "react";

export default function Words({ text = "", start = 0, className = "", wordClass = "lp-word" }) {
    const words = String(text).trim().split(/\s+/).filter(Boolean);
    return (
        <span className={`lp-words ${className}`.trim()}>
            {words.map((w, i) => (
                <Fragment key={`${w}-${i}`}>
                    <span className={wordClass} style={{ "--i": start + i }}>{w}</span>
                    {i < words.length - 1 ? " " : null}
                </Fragment>
            ))}
        </span>
    );
}
